import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import { IBaseToolbarFeature } from '../../common/feature/base-toolbar-interface';
import type { FontList } from '@src/utils/fonts/sync-font-list-loader';

export interface IFontFamilyFeature extends IBaseToolbarFeature {
    getFontFamily(): any;
    getFontFamilyName(): string;
    getFontList(): typeof FontList;
    renderSelectList(isDrawer?: boolean);
}

export const IFontFamilyFeature = Symbol.for('feature:toolbar-font-family');

DynamicLoaderRegistry.merge(IFontFamilyFeature, {
    useFactory: async () => {
        const { FontFamilyFeature } = await import('./font-family-feature');
        return FontFamilyFeature;
    },
    on: loadTask,
});
